import { Box, BoxProps } from "@chakra-ui/react";

export const Blockquote = (props: BoxProps) => (
  <Box pl={3} borderLeftWidth="3px" {...props} />
);
